import React, { createContext, useContext, useReducer } from "react";

type WebSocketState = {
  aiRes: number | null;
  imageGeneration: number | null;
  questionsGenerated: number | null;
};

type WebSocketAction =
  | { type: "AI_QUERY_RESPONSE"; payload: number | null }
  | { type: "IMAGE_GENERATION_COMPLETED"; payload: number | null }
  | { type: "QUESTIONS_GENERATED"; payload: number | null };

type WebSocketContextType = {
  state: WebSocketState;
  dispatch: React.Dispatch<WebSocketAction>;
};

const initialState: WebSocketState = {
  aiRes: null,
  imageGeneration: null,
  questionsGenerated: null,
};

const webSocketReducer = (
  state: WebSocketState,
  action: WebSocketAction
): WebSocketState => {
  switch (action.type) {
    case "AI_QUERY_RESPONSE":
      return {
        ...state,
        aiRes: action.payload,
      };
    case "IMAGE_GENERATION_COMPLETED":
      return {
        ...state,
        imageGeneration: action.payload,
      };
    case "QUESTIONS_GENERATED":
      return {
        ...state,
        questionsGenerated: action.payload,
      };
    default:
      return state;
  }
};

const WebSocketContext = createContext<WebSocketContextType | undefined>(
  undefined
);

export const WebSocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(webSocketReducer, initialState);

  return (
    <WebSocketContext.Provider value={{ state, dispatch }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketAiContext = () => {
  const context = useContext(WebSocketContext);

  if (!context) {
    throw new Error(
      "useWebSocketAiContext must be used within WebSocketProvider"
    );
  }

  return context;
};
